module.exports = require("react-immutable-proptypes");


//////////////////
// WEBPACK FOOTER
// external "react-immutable-proptypes"
// module id = 9
// module chunks = 0